import axios from "axios";

var baseURL = "https://loc.twnew.de";

if (
  window.location.hostname == "localhost" ||
  window.location.hostname == "loc.twnew.de"
) {
  baseURL = "https://loc.twnew.de";
}

if (window.location.hostname == "www.teamwaizmann.de") {
  baseURL = "https://www.teamwaizmann.de";
}

const http = axios.create({
  baseURL: baseURL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

export default http;
